import Vue from "vue";
import Vuex from "vuex";
import { stat } from "fs";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    zoom: 7,
    lineLength: 0,
    points: [],
    draw: null,
    layers: [
      {
        name: "Economic Regions",
        selected: false,
        value: 0,
        id: 0
      },
      {
        name: "Countries",
        selected: false,
        value: 0,
        id: 1
      },
      {
        name: "Draw",
        selected: false,
        value: 0,
        id: 1
      }
    ]
  },
  getters: {
    getTotalLenght: state => state.lineLength,
    getPoints: state => state.points
  },
  mutations: {
    SET_LENGTH(state, payload) {
      state.lineLength = payload;
    },
    SET_POINTS(state, payload) {
      state.points = payload;
    },
    SET_LAYERS(state, payload) {
      state.layers = payload;
    },
    SET_ZOOM(state, payload) {
      state.zoom = payload;
    }
  },
  actions: {
    setLength({ commit }, data) {
      commit("SET_LENGTH", data);
    },
    setPoints({ commit }, data) {
      commit("SET_POINTS", data);
    },
    setLayers({ commit }, data) {
      commit("SET_LAYERS", data);
    },
    setZoom({ commit }, data) {
      commit("SET_ZOOM", data);
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js